<template>
  <div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="기본 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="이미지" tip="회원 프로필 이미지로, 500x500의 이미지로 등록하는 것을 권장합니다.">
                  <input-img :url.sync="basicInfo.profile"></input-img>
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="아이디(이메일)*">
                  <input class="input"
                          :value="basicInfo.email"
                          @input="inputUserName"
                          placeholder="launchpack@launchpack.co.kr"
                          type="text" :disabled="inputDisabled" maxlength="30">
                  <!--<span v-if="!emailValid && basicInfo.username.length>0"></span>-->
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="이름">
                  <input class="input"
                          :value="basicInfo.name"
                          @input="e => basicInfo.name = e.target.value"
                          placeholder="홍길동"
                          type="text">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="비밀번호*">
                  <input class="input"
                        :value="basicInfo.password"
                        @input="e => basicInfo.password = e.target.value"
                         placeholder="비밀번호를 입력하세요."
                         type="password" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="비밀번호 확인*">
                  <input class="input"
                        :value="basicInfo.passwordCheck"
                        @input="e => basicInfo.passwordCheck = e.target.value"
                        placeholder="비밀번호를 확인하는 곳 입니다."
                        type="password" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="휴대전화번호">
                  <input class="input"
                        :value="basicInfo.phone"
                        @input="e => basicInfo.phone = e.target.value"
                         placeholder="010-1234-5678"
                        type="text" maxlength="13">
                </admin-form-item>
              </div>
              <div class="column is-3">
                <admin-form-item label="회원여부">{{ basicInfo.guest ? '비회원' : '회원' }}</admin-form-item>
              </div>
              <div class="column is-3">
                <admin-form-item label="유료회원">{{ basicInfo.paid ? 'O' : '-' }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="주소">
                  <lp-address :data.sync="basicInfo.address"></lp-address>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
        <div class="box">
          <admin-box-item title="부가 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="생년월일">
                  <div class="columns is-multiline">
                    <div class="column">
                      <lp-adm-drop-input @onSelect="selYear" :selectVal="basicInfo.birth.year" :data.sync="yearArr"
                                         placeholder="연" listAlign="center" :number_length="4"
                      ></lp-adm-drop-input>
                    </div>
                    <div class="column">
                      <lp-adm-drop-input @onSelect="selMonth" :selectVal="basicInfo.birth.month" :data.sync="monthArr"
                                         placeholder="월" listAlign="center" :number_length="2"
                      ></lp-adm-drop-input>
                    </div>
                    <div class="column">
                      <lp-adm-drop-input @onSelect="selDate" :selectVal="basicInfo.birth.date" :data.sync="dateArr"
                                         placeholder="일" listAlign="center" :number_length="2"
                      ></lp-adm-drop-input>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="성별">
                  <lp-radio :val.sync="basicInfo.gender"
                            value_name="value"
                            label_name="label"
                            :data="gender"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :label="isLaunchpack ? '가입경로' : '가입경로/연동 SNS 계정 정보'" tip="회원이 SNS 계정을 이용하여 회원가입하는 경우 수집되는 데이터이며, 관리자가 회원 등록할 때에는 입력하실 수 없습니다.">
                  <input class="input"
                         :value="basicInfo.channel"
                         @input="e => basicInfo.login_type = e.target.value"
                         type="text"
                         maxlength="20"
                         :disabled="true">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="마케팅 수신 동의">
                  <lp-check-bool :checkedVal.sync="basicInfo.email_agreement" label="이메일 수신동의" style="margin-bottom:4px"></lp-check-bool>
                  <lp-check-bool :checkedVal.sync="basicInfo.push_agreement" label="앱푸시 수신동의" style="margin-bottom:4px"></lp-check-bool>
                  <lp-check-bool :checkedVal.sync="basicInfo.sms_agreement" label="sms 수신동의"></lp-check-bool>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-6" v-if="basicInfo.id">
        <div class="box">
          <launch-talk :userId="basicInfo.id" :isMemo="true"></launch-talk>
        </div>
      </div>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>


  </div>
</template>

<script>
  import moment from 'moment';
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import InputImg from '../../module/common/InputImg'
  import LpAddress from '../../module/common/LpAddress'
  import LpAdmDropInput from '../../module/common/LpAdmDropInput'
  import LpDateDropInput from "../../module/common/LpDateDropInput";
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import AdminLogMemo from '../../module/common/AdminLogMemo'
  import InputParam from "../../module/custom/InputParam";
  import CreateMixin from "@/mixins/CreateMixin"
  import UserPointManage from "./components/UserPointManage";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LaunchTalk from "../../module/common/LaunchTalk";

  export default {
    name: 'UserRegLp',
    layout: 'Main',
    components: {
      LaunchTalk,
      LpCheckBool,
      UserPointManage,
      InputParam,
      LpSortDropDown,
      LpDateDropInput,
      LpInputText,
      LpRadio, InputImg, LpAddress,
      LpAdmDropInput,
      AdminLogMemo
    },
    mixins: [
      CreateMixin
    ],
    data() {
      return {
        talks: [],
        selectedTalk: undefined,
        // 맞춤 DB
        param_list:[],
        user_param: [],
        testModal: false,
        customDB: [],
        // 연락처
        phone: [
          {label: ''}
        ],
        // 기본 정보
        basicInfo: {
          birth: {
            year: '',
            month: '',
            date: '',
          },
          gender: '',
          profile: '',
          username: '',
          // id: '',
          password: '',
          passwordCheck: '',
          email: '',
          address: {
            full: '',
            sido: '',
            sigungu: '',
            dong: '',
            zipcode: '',
            detail: ''
          },
          name: '',
          nickname: '',
          joined_type: '',
          phone: ''
        },
        // 맞춤 DB필드 정보
        customizedInfo: {},
        // 서비스 사용 정보
        // 고객 히스토리 정보
        memo_logs: [],
        // 성별 라디오 용
        gender: [
          {label: '여자', value: 'female'},
          {label: '남자', value: 'male'},
        ],
        // 생년월일 Array
        yearArr: [],
        monthArr: [],
        dateArr: [],
        emailValid: false,
        userGradeList: [],
        talkId: 0,
      }
    },
    computed: {
      inputDisabled() {
        if (this.$route.query.id) {
          return true;
        }
      },
      selectedGrade() {
        let grade = find(this.userGradeList, 'value', this.basicInfo.grade);
        if(grade)
          return grade.label;
        else
          return '';
      },
      userName() {
        let user = find(this.emailArr, 'value', this.basicInfo.username2);
        if (user !== undefined)
          return user.label;
        else
          return '';
      }
    },
    watch: {
      'basicInfo.username'(n) {
        this.emailValid = this.validateEmail(n);
      },
      'basicInfo.phone'(n) {
        if(n) this.basicInfo.phone = autoHyphenPhone(this.basicInfo.phone)
      },
      'basicInfo.birth.year'(n) {
        this.monthArr = [];
        this.dateArr = [];

        let month = 1;
        for (let i = 0; i < 12; i++) {
          let monthObj = {
            label: month.toString(),
            value: month.toString()
          };
          this.monthArr.push(monthObj);
          month++;
        }

        let day = (this.basicInfo.birth.year).toString() + '-' + (this.basicInfo.birth.month).toString();
        day = moment(day).endOf('month').format('DD');

        for (let i = 1; i <= day; i++) {
          this.dateArr.push({
            label: i.toString(),
            value: i.toString()
          });
        }
      },
      'basicInfo.birth.month'(n) {
        this.dateArr = [];
        let day = (this.basicInfo.birth.year).toString() + '-' + (this.basicInfo.birth.month).toString();
        day = moment(day).endOf('month').format('DD');

        for (let i = 1; i <= day; i++) {
          this.dateArr.push({
            label: i.toString(),
            value: i.toString()
          });
        }
      },
    },
    created() {
      // 연/월/일 Array 생성
      let century = parseInt(moment().format('YYYY')) - 100;
      for (let year = parseInt(moment().format('YYYY')); year >= century; year--) {
        this.yearArr.push({
          label: year.toString(),
          value: year.toString()
        });
      }

      for (let month = 1; month <= 12; month++) {
        this.monthArr.push({
          label: month.toString(),
          value: month.toString()
        });
      }

      this.getData();
      this.getTalks();

      let day = (this.basicInfo.birth.year).toString() + '-' + (this.basicInfo.birth.month).toString();
      day = moment(day).endOf('month').format('DD');

      for (let i = 1; i <= day; i++) {
        this.dateArr.push({
          label: i.toString(),
          value: i.toString()
        });
      }

    },
    methods: {
      convertLoginType(name) {
        const types = {
          email: '이메일',
          kakao: '카카오',
          naver: '네이버',
          facebook: '페이스북',
          google: '구글',
          apple: '애플'
        };
        return types[name];
      },
      inputUserName (e){
        this.basicInfo.username = e.target.value;
        this.basicInfo.email = e.target.value;
      },
      paramAllList(){
        // 파라미터 리스트
        this.$axios.get('admin/member/user/param').then(res=>{
          if(res.status===200){
            this.param_list = res.data;
            let result = this.paramChecker(this.param_list, this.user_param);
            if(result.length > 0) this.user_param = this.user_param.concat(result);
            this.user_param.sort((a,b) => {
              return a.id > b.id ? 1 : a.id < b.id ? -1 : 0;
            });
          }
        })
      },
      validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      // 연 선택
      selYear(item) {
        if (item === undefined) return;
        this.basicInfo.birth.year = item.label;
      },
      // 월 선택
      selMonth(item) {
        if (item === undefined) return;
        this.basicInfo.birth.month = item.label;
      },
      // 일 선택
      selDate(item) {
        if (item === undefined) return;
        this.basicInfo.birth.date = item.label;
      },
      getTalks() {
        if(this.$route.query.id) {
          this.$axios.get(this.getUrl(`launchpack/talk_user/${this.$route.query.id}`)).then(res=> {
            this.talks = res.data;
            if(this.talks.length>1) {
              this.selectedTalk = this.talks[1];
            } else {
              this.selectedTalk = this.talks[0];
            }
          });
        }
      },
      getData() {
        // 유저 정보가 있는 경우 가져오기
        if(this.$route.query.id) {
          this.$axios.get(this.getUrl('member/user/' + this.$route.query.id)).then(res => {
              if (res.status === 200) {
                this.basicInfo = res.data.user;
                let channel = '';
                let username = res.data.user.username;
                if(username.indexOf('@')>-1) {
                  channel = '이메일';
                } else if(username.indexOf('$')>-1) {
                  channel = this.convertLoginType(username.split('$')[0]);
                }
                let sns = [];
                for(let key of ['kakao','facebook','naver','apple','google']) {
                  if(this.basicInfo[`${key}_id`] && this.basicInfo[`${key}_id`] !== '') {
                    sns.push(this.convertLoginType(key));
                  }
                }
                if(sns.length>0) {
                  channel += ' / ' + sns;
                }

                this.basicInfo.channel = channel;

                let birth = res.data.user.birth;
                if (birth) {
                  this.basicInfo.birth = {
                    year: moment(birth).year(),
                    month: moment(birth).month() + 1,
                    date: moment(birth).date()
                  }
                }
                else {
                  this.basicInfo.birth = {
                    year: '',
                    month: '',
                    date: ''
                  }
                }
                let address = res.data.user.address;
                if (!address) {
                  this.basicInfo.address = {
                    sido: '',
                    sigungu: '',
                    dong: '',
                    detail: '',
                    post_code: '',
                    old: '',
                    new: ''
                  }
                }
                this.memo_logs = res.data.memo_logs;
                this.paramAllList();
              }
            });
        }
        else this.paramAllList();
      },
      saveData() {
        let errMsg = '';
        if (!this.basicInfo.username) errMsg = '아이디를';
        //else if(!this.basicInfo.name) errMsg = '이름을';
        else if (this.basicInfo.phone && this.basicInfo.phone.split('-').length < 3) errMsg = '휴대전화번호를 알맞게';
        //else if (!this.basicInfo.birth.year || !this.basicInfo.birth.month || !this.basicInfo.birth.date) errMsg = '생년월일을 알맞게'
        else if (this.login_type==='email' && !this.emailValid) errMsg = '이메일 타입에 맞게';
        //else if(this.basicInfo.nickname === '') errMsg = '닉네임을';
        if (!this.$route.query.id) {
          if (!this.basicInfo.password) errMsg = '비밀번호를';
          else if (!this.basicInfo.passwordCheck) errMsg = '비밀번호 확인을';
        }

        if (errMsg) {
          this.toast(errMsg + ' 입력해주세요.');
          return;
        }
        if (this.basicInfo.password !== this.basicInfo.passwordCheck) {
          this.toast('비밀번호를 확인해주세요.');
          return;
        }
        if (this.isLaunchpack && /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(this.basicInfo.password)) {
          this.toast('영문으로 비밀번호를 입력하세요.');
          return;
        }


        // 생년월일 데이터 맞춰서 보내기
        let basicInfo = this.cloneItem(this.basicInfo);
        let year = basicInfo.birth.year;
        let month = basicInfo.birth.month;
        let date = basicInfo.birth.date;
        let errBirth = false;
        if (!year && !month && !date) {
          basicInfo.birth = '';
        }
        else if (year && !month && !date) errBirth = true;
        else if (year && month && !date) errBirth = true;
        else if (!year && month && date) errBirth = true;
        else if (!year && !month && date) errBirth = true;
        else if (!year && month && !date) errBirth = true;
        else {
          let birth = basicInfo.birth.year + '-' + basicInfo.birth.month + '-' + basicInfo.birth.date
          basicInfo.birth = birth;
        }

        if(errBirth===true) {
          this.toast('생년월일을 모두 선택해주세요.');
          return;
        }

        // 전화번호 (-)하이폰 없애서 보내기
        let phone = '';
        let phone_copy = '';
        if(basicInfo.phone){
          phone = basicInfo.phone.split('-')
          for (let i = 0; i < phone.length; i++) {
            phone_copy += phone[i];
          }
        }
        basicInfo.phone = phone_copy;
        this.$store.commit('setLoading', true);
        if (this.$route.query.id) {
          // user_param 추가
          basicInfo.params = this.user_param;
          this.$axios.patch(this.getUrl('member/user/' + this.$route.query.id), basicInfo).then(res => {
            if (res.status === 200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('user'));
            }
          }).catch(error => {
            if (error.response) {
              this.$store.commit('setLoading', false);
              this.toast(error.response.data.message);
            }
          });
        }
        else {
          basicInfo.params = this.user_param;
          this.$axios.post(this.getUrl('member/user'), basicInfo).then(res => {
            if (res.status === 200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('user'));
            }
          }).catch(error => {
            if (error.response) {
              this.$store.commit('setLoading', false);
              this.toast(error.response.data.message);
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .talk-title
    font-weight 600
    margin-bottom 8px
  .talk-item
    padding 4px 8px
  .talk-item:hover
    background-color #eeeeee
  .talk-item-selected
    color #ff5722
  .channel-list
    max-height 504px
    overflow-y auto
</style>
